module.exports = __webpack_public_path__ + "83a69f3440d0567e276cc57306c3b40b.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/folder_delete_2x.png
// module id = 17
// module chunks = 0 1 2 3 4